<template>
  <div class="row z-depth-1">
    <div class="col s12">
        <table class="striped centered responsive-table">
            <thead>
                <tr>
                    <th>{{$t('article.headline')}}</th>
                    <th>{{$t('article.date')}}</th>
                    <th>{{$t('global.keywords')}}</th>
                    <th>{{$t('global.downloadFile')}}</th> 
                </tr>
            </thead>
            <tbody>
                <tr v-for="article in articles" :key="article.id">
                   <td >{{article.headline}}</td> 
                       <td>{{article.date | formatDate}}</td>
                       <td >{{article.keywords}}</td>
                       <td>
                            <div v-for="attachment in article.attachments" :key="attachment.url">
                                <a target="_blank" :href="attachment.url">{{attachment.fileName}}</a>
                            </div>
                        </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
import axiosCommon from '@/axios-common/axios-common';
export default {
name:'Articles',
dependencies:['localeService'],
data () {
    return{
        articles:{},
        press:{}
    }
},
 mounted() {
        this.getMediaData()
    },
      methods: {
            getMediaData(){
            let vm = this;
               axiosCommon.get(`/o/newsArticles?language=${vm.localeService.getCurrentLocale()}&`)
        .then(response => {
         this.articles = response.data
        })
        .catch(e => {
          console.log('Activity')
          console.log(e)
        })
            }
      }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/media/articles.vue